import CommonHeader from "../../../components/ui/CommonHeader";
import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";
import SuccessStory from "./_components/success-story";

export default function Story() {
  return (
    <WebLayout>
      <CommonHeader
        title="সফলতার গল্প"
        description={
          <>
            আজই শুরু করুন আপনার স্কি
            <span className="opacity-0 absolute">.</span>ল ডেভেলপমেন্টের যাত্রা
          </>
        }
      />
      <SuccessStory />
      <Platform />
      <Footer isPlatform={true} />
    </WebLayout>
  );
}
